import React from 'react';
// ----------------------------------------------------------------------------------------------------
import CenterPofile from './center_profile';
import TrainnerProfile from './trainers/trainer_profile';
import SequenceProfile from '../../../components/atoms/sequences/sequence_profile';
import LectureProfile from '../../../components/atoms/lectures/lecture_profile';
import CategoryProfile from '../../../components/atoms/categories/category_profile';
// ----------------------------------------------------------------------------------------------------
import icoCenter from '../../../assets/images/ico_center.png';
import icoTrainer from '../../../assets/images/ico_trainer.png';
import icoSequence from '../../../assets/images/ico_sequece.png';
import icoLecture from '../../../assets/images/ico_lecture.png';
import icoCategory from '../../../assets/images/ico_exercise.png';

import icoCenterW from '../../../assets/images/ico_center_white.png';
import icoTrainerW from '../../../assets/images/ico_trainer_white.png';
import icoSequenceW from '../../../assets/images/ico_sequece_white.png';
import icoLectureW from '../../../assets/images/ico_lecture_white.png';
import icoCategoryW from '../../../assets/images/ico_exercise_white.png';

// ----------------------------------------------------------------------------------------------------
const CenterTabs = (props) => {
  const accountId = props?.accountId;
  return [
    {
      title: '센터정보',
      width: '12.7rem',
      height: '3.8rem',
      icon: (checked) =>
        checked ? (
          <img width={24} height={24} src={icoCenterW} />
        ) : (
          <img width={24} height={24} src={icoCenter} />
        ),
      component: <CenterPofile {...props} />,
    },

    {
      title: '트레이너',
      width: '12.7rem',
      height: '3.8rem',
      icon: (checked) =>
        checked ? (
          <img width={24} height={24} src={icoTrainerW} />
        ) : (
          <img width={24} height={24} src={icoTrainer} />
        ),
      component: <TrainnerProfile {...props} />,
    },

    {
      title: '시퀀스',
      width: '12.7rem',
      height: '3.8rem',
      icon: (checked) =>
        checked ? (
          <img width={24} height={24} src={icoSequenceW} />
        ) : (
          <img width={24} height={24} src={icoSequence} />
        ),
      component: <SequenceProfile {...props} accountId={null} />,
    },

    {
      title: '강의',
      width: '12.7rem',
      height: '3.8rem',
      icon: (checked) =>
        checked ? (
          <img width={24} height={24} src={icoLectureW} />
        ) : (
          <img width={24} height={24} src={icoLecture} />
        ),
      component: <LectureProfile {...props} accountId={null} />,
    },
    {
      title: '카테고리',
      width: '12.7rem',
      height: '3.8rem',
      icon: (checked) =>
        checked ? (
          <img width={24} height={24} src={icoCategoryW} />
        ) : (
          <img width={24} height={24} src={icoCategory} />
        ),
        component: <CategoryProfile {...props} centerId={props.centerId} plan={props.plan} />,
      },
  ];
};
export default CenterTabs;
